function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCombobox } from 'downshift';
export var useStateReducer = _ref => {
  var {
    formatSelectedValue,
    hasFilteredOptions,
    hasEmptyState,
    hasCreatableOption,
    shouldOpenMenuOnClick,
    shouldShowPresetOptions,
    clearSelectedOption,
    setQuery,
    onInputChange
  } = _ref;

  var stateReducer = (_state, actionAndChanges) => {
    var {
      type: changeType,
      changes
    } = actionAndChanges;
    var {
      ControlledPropUpdatedSelectedItem,
      ItemClick,
      InputBlur,
      InputKeyDownEscape,
      FunctionOpenMenu,
      InputClick,
      InputChange,
      InputKeyDownArrowDown,
      InputKeyDownArrowUp
    } = useCombobox.stateChangeTypes;
    var hasInputValue = Boolean(changes.inputValue);
    var otherChanges = changes;

    switch (changeType) {
      case ControlledPropUpdatedSelectedItem:
        return _objectSpread(_objectSpread({}, otherChanges), {}, {
          isOpen: false,
          inputValue: changes.selectedItem ? formatSelectedValue(changes.selectedItem) : ''
        });

      case ItemClick:
      case InputBlur:
      case InputKeyDownEscape:
        setQuery(null);

        if (!hasInputValue) {
          clearSelectedOption();
        }

        return _objectSpread(_objectSpread({}, otherChanges), {}, {
          inputValue: hasInputValue && changes.selectedItem ? formatSelectedValue(changes.selectedItem) : ''
        });

      case FunctionOpenMenu:
        return _objectSpread(_objectSpread({}, otherChanges), {}, {
          highlightedIndex: 0
        });

      case InputClick:
        return _objectSpread(_objectSpread({}, otherChanges), {}, {
          isOpen: shouldShowPresetOptions && (hasFilteredOptions || hasEmptyState || hasCreatableOption || shouldOpenMenuOnClick)
        });
      // Using this and not `onInputValueChange` will trigger input changes only if the user typed in the input and not if the input value is changed due to selection.

      case InputChange:
        {
          var _changes$inputValue;

          onInputChange((_changes$inputValue = changes.inputValue) !== null && _changes$inputValue !== void 0 ? _changes$inputValue : '');
          return _objectSpread(_objectSpread({}, otherChanges), {}, {
            isOpen: hasInputValue || hasFilteredOptions
          });
        }

      case InputKeyDownArrowDown:
      case InputKeyDownArrowUp:
        {
          var showEmptyState = hasEmptyState && !hasCreatableOption;
          return _objectSpread(_objectSpread({}, otherChanges), {}, {
            isOpen: shouldShowPresetOptions ? hasFilteredOptions || showEmptyState || hasCreatableOption : hasFilteredOptions || showEmptyState
          });
        }

      default:
        return otherChanges;
    }
  };

  return stateReducer;
};
//# sourceMappingURL=useStateReducer.js.map